<!-- Breadcrumb Navigation -->
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Medical Test</li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">

        <!-- Card Wrapper -->
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">

            <!-- Header Section -->
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-9 col-md-6">
                    <h5 class="mb-0 text-dark fw-bold">Medical Test</h5>
                </div>
                <div class="col-3 col-md-6 d-flex justify-content-end" *appHasRole="['WARD-ADD']">
                    <!-- Add Wards Button -->
                    <!-- <button type="button"
                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                        (click)="openModel('Add', null)" style="width: 25px; height: 25px;" title="Add New Wards">
                        <mat-icon fontIcon="add"></mat-icon>
                    </button> -->
                </div>
            </div>

            <hr class="m-0 p-0" />

            <!-- Search Box -->
            <div class="row">
                <div class="col-12">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search By Name</mat-label>
                        <input matInput name="testName" (keyup)="onSearchChange($event)" class="w-100" />
                    </mat-form-field>
                </div>
            </div>

            <!-- Table Section -->
            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered table-hover compact-table">

                        <!-- Sr No -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let i = index">
                                {{ i + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Medical Test ID -->
                        <ng-container matColumnDef="medicalTestId">
                            <th mat-header-cell *matHeaderCellDef>Test ID</th>
                            <td mat-cell *matCellDef="let element">
                                #{{ element.MedicalTestAutoId || '-' }}
                            </td>
                        </ng-container>

                        <!-- Doctor -->
                        <ng-container matColumnDef="doctor">
                            <th mat-header-cell *matHeaderCellDef>Doctor</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.DoctorId?.name || '-' }}
                            </td>
                        </ng-container>

                        <!-- Person -->
                        <ng-container matColumnDef="person">
                            <th mat-header-cell *matHeaderCellDef>Person</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.PersonId?.name || '-' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="testName">
                            <th mat-header-cell *matHeaderCellDef>Test Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.name || '-' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="tests">
                            <th mat-header-cell *matHeaderCellDef>Tests</th>

                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element.Tests?.length; else noTests">
                                    <span *ngFor="let t of element.Tests" class="badge bg-primary me-1 mb-1">
                                        {{ t.name }}
                                    </span>
                                </ng-container>

                                <ng-template #noTests>-</ng-template>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="otherTests">
                            <th mat-header-cell *matHeaderCellDef>Other Tests</th>

                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element.OtherTest?.length; else noOther">
                                    <span *ngFor="let t of element.OtherTest" class="badge bg-success me-1 mb-1">
                                        {{ t.name }} (₹{{ t.price }})
                                    </span>
                                </ng-container>

                                <ng-template #noOther>-</ng-template>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="badge" [ngClass]="{
                                  'bg-success': element.Status === 1,
                                  'bg-secondary': element.Status !== 1
                                }">
                                    {{ element.Status === 1 ? 'Pending' : 'Rejected' }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="action-cell text-center">
                                Action
                            </th>

                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-2 justify-content-center">

                                    <!-- View -->
                                    <mat-icon matTooltip="View Details" fontIcon="visibility" class="c_btn" 
                                   (click)="openDetailsModal(element)">
                                    </mat-icon>

                                    <!-- Edit -->
                                    <mat-icon *ngIf="userDataService?.roleMatch(['MEDICAL-TEST-CHANGE'])" matTooltip="Edit Test"
                                        fontIcon="edit" class="c_btn" (click)="openModel('Edit', element)">
                                    </mat-icon>

                                    <!-- Delete -->
                                    <!-- <mat-icon *ngIf="userDataService?.roleMatch(['WARD-DELETE'])"
                                        matTooltip="Delete Test" fontIcon="delete" class="c_btn text-danger"
                                        (click)="deleteItem(element._id)">
                                    </mat-icon> -->

                                </div>
                            </td>
                        </ng-container>
                        <!-- <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>

                            <td mat-cell *matCellDef="let element">

                               
                                @if (userDataService?.roleMatch(['WARD-EDIT'])) {
                                <button mat-icon-button class="btn btn-sm" (click)="openModel('Edit', element._id)">
                                    <mat-icon fontIcon="edit" class="c_btn"></mat-icon>
                                </button>
                                }

                              
                                @if (userDataService?.roleMatch(['WARD-DELETE'])) {
                                <button mat-icon-button class="btn btn-sm text-danger"
                                    (click)="deleteItem(element._id)">
                                    <mat-icon fontIcon="delete" class="c_btn"></mat-icon>
                                </button>
                                }

                            </td>
                        </ng-container> -->

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
            </div>

            <!-- Pagination -->
            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllCategories($event)"></mat-paginator>

        </app-card>
    </div>
</div>



<!-- Edit Modal -->
<div class="modal fade" id="wardModal" tabindex="-1" aria-labelledby="wardModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title fs-5 fw-semibold" id="wardModalLabel">
                    {{ formType }} Medical Test
                </h5>
                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body pt-1">
                <form [formGroup]="categoryForm" (ngSubmit)="submit()">


                    <!-- Name -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Test Name</label>
                        <input type="text" formControlName="name" class="form-control form-control-sm" />
                    </div>

                    <!-- Tests -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Tests</label>

                        <div *ngFor="let t of categoryForm.value.Tests" class="border rounded p-2 mb-2 bg-light">

                            <div class="row align-items-center">

                                <!-- Test Name -->
                                <div class="col-7">
                                    <label class="small text-muted">Test Name</label>
                                    <input type="text" [value]="t.name" class="form-control form-control-sm" readonly />
                                </div>

                                <!-- Price -->
                                <div class="col-5">
                                    <label class="small text-muted">Price (₹)</label>
                                    <input type="number" [value]="t.price" class="form-control form-control-sm"
                                        readonly />
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label small text-muted">Status</label>
                        <select formControlName="Status" class="form-control form-control-sm">
                            <option [ngValue]="1">Pending</option>
                            <option [ngValue]="2">Rejected</option>
                        </select>
                    </div>

                    

                    <div class="mb-3">
                        <label class="form-label small text-muted">Upload Result Files</label>
                        <input type="file" multiple (change)="onFileSelect($event, 'result')" />
                    </div>


                    <!-- Modal Actions -->
                    <div class="modal-footer border-0 pt-0">
                        <button type="button" class="btn btn-sm btn-light" (click)="hideModel()">Cancel</button>
                        <button type="submit" class="btn btn-sm btn-primary px-3" [disabled]="categoryForm.invalid">
                            Save
                        </button>
                    </div>

                </form>
            </div>
            
        </div>
    </div>
</div>

<!-- Details Modal -->
<div class="modal fade" id="detailsModal" tabindex="-1" aria-labelledby="detailsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header border-0">
                <h5 class="modal-title fs-5 fw-semibold" id="detailsModalLabel">
                    Medical Test Details
                </h5>
                <button type="button" class="btn-close" (click)="closeDetailsModal()"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body" *ngIf="selectedItem">
                <div class="row">
                    <!-- Left Column: Details -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <strong>Medical Test ID:</strong> {{ selectedItem.MedicalTestAutoId }}
                        </div>
                        <div class="mb-3">
                            <strong>Name:</strong> {{ selectedItem.name || '-' }}
                        </div>
                        <div class="mb-3">
                            <strong>Person:</strong> {{ selectedItem.PersonId?.name || '-' }}
                        </div>
                        <div class="mb-3">
                            <strong>Doctor:</strong> {{ selectedItem.DoctorId?.name || '-' }}
                        </div>
                        <div class="mb-3">
                            <strong>Status:</strong> {{ selectedItem.Status === 1 ? 'Active' : 'Inactive' }}
                        </div>
                        <div class="mb-3">
                            <strong>Tests:</strong>
                            <div *ngIf="selectedItem.Tests?.length; else noTests">
                                <span *ngFor="let t of selectedItem.Tests" class="badge bg-primary me-2 mb-2">
                                    {{ t.name }} (₹{{ t.price }})
                                </span>
                            </div>
                            <ng-template #noTests>-</ng-template>
                        </div>
                        <div class="mb-3">
                            <strong>Other Tests:</strong>
                            <div *ngIf="selectedItem.OtherTest?.length; else noOther">
                                <span *ngFor="let t of selectedItem.OtherTest" class="badge bg-success me-2 mb-2">
                                    {{ t.name }} (₹{{ t.price }})
                                </span>
                            </div>
                            <ng-template #noOther>-</ng-template>
                        </div>
                        <div class="mb-3">
                            <strong>Remark:</strong> {{ selectedItem.Remark || '-' }}
                        </div>
                        <div class="mb-3">
                            <strong>Created At:</strong> {{ selectedItem.createdAt | date:'medium' }}
                        </div>
                        <div class="mb-3">
                            <strong>Updated At:</strong> {{ selectedItem.updatedAt | date:'medium' }}
                        </div>
                    </div>

                    <!-- Right Column: Images -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <strong>Test Files:</strong>
                            <div class="row g-2" *ngIf="selectedItem.Test_Files?.length; else noTestFiles">
                                <div class="col-6" *ngFor="let file of selectedItem.Test_Files">
                                    <img *ngIf="getImg(file) as imageUrl" [src]="imageUrl" class="img-fluid rounded"
                                        alt="Test File" style="max-height: 150px; object-fit: contain;" />
                                </div>
                            </div>
                            <ng-template #noTestFiles>No test files</ng-template>
                        </div>
                        <div class="mb-3">
                            <strong>Result Files:</strong>
                            <div class="row g-2" *ngIf="selectedItem.Result_Files?.length; else noResultFiles">
                                <div class="col-6" *ngFor="let file of selectedItem.Result_Files">
                                    <img *ngIf="getImg(file) as imageUrl" [src]="imageUrl" class="img-fluid rounded"
                                        alt="Result File" style="max-height: 150px; object-fit: contain;" />
                                </div>
                            </div>
                            <ng-template #noResultFiles>No result files</ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer border-0">
                <!-- <button type="button" class="btn btn-sm btn-danger me-2" (click)="deleteItem(selectedItem._id)">
                    <mat-icon fontIcon="delete"></mat-icon> Delete
                </button>
                <button type="button" class="btn btn-sm btn-warning me-2" (click)="openModel('Edit', selectedItem._id)">
                    <mat-icon fontIcon="edit"></mat-icon> Edit
                </button> -->
                <button type="button" class="btn btn-sm btn-primary" (click)="closeDetailsModal()">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>